import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_czn89sb32s: FaireBrandEntity = {
  token: "b_czn89sb32s",
  type: "brand",
  name: "Oddi",
  avatarUrl:
    "https://cdn.faire.com/fastly/4eeb3c42f680545972d4ec3ebf278a1c92075829604e28a52afa2e805579f150.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e884b51cd9fbd97bdf6f42bc090a3336eb345d8817f32f6c6e9042f082b441e8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4eeb3c42f680545972d4ec3ebf278a1c92075829604e28a52afa2e805579f150.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e884b51cd9fbd97bdf6f42bc090a3336eb345d8817f32f6c6e9042f082b441e8.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 317,
  isTopShop: true,
  isInsider: true,
  description:
    "Oddi is a Bohemian-inspired women's young contemporary clothing brand based in Los Angeles \nand carries sizes S through 3XL, and also Kids clothing. \n\nAt Oddi, we live out our dreams every day creating art through fashion and spreading our love for the world.\n\nWe are one unit sharing a vision, working together to produce beautiful things.\n\nLove, passion, ambition, and imagination run through our veins. We are romantics at heart, inspired by the Bohemian spirit, drawing from nature's beauty, and breathing new life into vintage aesthetic.\n\nWe dress the bright and diligent woman with a warm, sincere heart who is blossoming into her better and stronger self.\n\nWe always strive for comfort and charm as we create one-of-a-kind pieces that adapt to the modern woman's daily life and give her the confidence and grace to illuminate the world with her gifts.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:34.759Z",
    importedBy: "entity-db-cli",
  },
};
